import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { ViewState } from "../../../common/config/AppConstants";
import * as format from "../../../common/FormatFunctions";
import { ListValueDisplay } from "../../Common/ListValueDisplay";
import { ProductDisplay } from "../../Products/UI/ProductDisplay";

export class WorkItemDisplay extends React.Component {
  setUpProductColumns = () => {
    let localCols = [];
    localCols.push(pr.getTableColumn("name", "Name"));
    localCols.push(pr.getTableColumn("shortDescription", "Description"));
    localCols.push(pr.getTableColumn("operationalType", "Type"));

    return localCols;
  };

  render() {
    var bean = this.props.data;
    if (!format.isNotNull(bean)) {
      return <div></div>;
    }
    return (
      <div
        className="ui-g-12 card-round"
        onClick={e => {
          if (format.isFunction(this.props.onClick)) {
            this.props.onClick(bean);
          }
        }}
      >
        <div className="ui-g-12">
          {/*Empty div for spacing*/}
          <label />
        </div>
        <div className="ui-g-12">
          <div className="ui-g-6">
            <b>Name: </b>
            <label>{bean.name || "Not Set"}</label>
          </div>
          <div className="ui-g-6">
            <b>Short Description: </b>
            <label>{bean.shortDescription || "Not Set"}</label>
          </div>
        </div>
        <div className="ui-g-12">
          <div className="ui-g-6">
            <b>Quantity: </b>
            <label>{bean.quantity || "Not Set"}</label>
          </div>
        </div>
        <div className="ui-g-12">
          <div className="ui-g-6">
            <b>Station: </b>
            <label>{bean.stationId || "Not Set"}</label>
          </div>
        </div>

        <div className="ui-g-12">
          <b>Status : </b>
          <label>{bean.status || "Not Set"}</label>
        </div>
        <React.Fragment>
          <h3>Final Product</h3>

          {this.getProducts(bean)}
        </React.Fragment>
      </div>
    );
  }
  getProducts = bean => {
    if (!format.isNotNull(bean.productList)) {
      return <React.Fragment></React.Fragment>;
    }
    let columns = this.setUpProductColumns().map((col, i) => {
      return (
        <pr.Column
          key={col.field}
          field={col.field}
          header={col.header}
          // sortable={col.sortable}
          // filter={col.filter}
          // filterMatchMode={col.filterMatchMode}
          style={col.style}
        />
      );
    });

    return (
      <React.Fragment>
        <pr.DataTable
          ref={el => {
            this.dt = el;
          }}
          reorderableColumns={false}
          selectionMode="single"
          onSelectionChange={e => {}}
          value={bean.productList}
          dataKey="id"
          emptyMessage="No Properties"
          // header={
          //   <div>
          //     <label className="header-label">Accepted Values</label>
          //   </div>
          // }
          rows={100}
          autoLayout={true}
        >
          {columns}
          <pr.Column
            key="view"
            body={this.getProductViewTemplate}
            style={{ textAlign: "center", width: "8em" }}
          />
        </pr.DataTable>
      </React.Fragment>
    );
  };

  getProductViewTemplate = (rowData, column) => {
    return (
      <pr.Button
        type="button"
        icon="pi pi-ellipsis-h"
        className="p-button-success"
        onClick={() => {}}
        // onClick={() => {
        //   this.setState({ partSelected: rowData, partAdded: true });
        // }}
        style={{ marginRight: ".5em", background: "green" }}
      ></pr.Button>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Work/UI/WorkItemDisplay.js